(function ($) {
  $( document ).ready(function() {

        var frameColor = $('.collection-frames-swatches ul li:first-of-type input').val();
        $('.frame-name-selected').text(frameColor);
        $('.collection-frames-swatches ul li:first-of-type input').each(function(){
          $(this).prop('checked', true);
          $(this).addClass('checked');
          $(this).click();
        });

  });

  $('.main-frames .collection-frames-swatches input:radio').click(function(e){
      e.preventDefault();
      $('.main-frames .collection-frames-swatches input:radio').each(function(){
        $(this).removeClass('checked');
      });
      $(this).addClass('checked');
      if($(this).is(":checked")) {
          var frameColor = $(this).val();
          $('#product-grid').attr('data-frame-color', frameColor);
          $('.frame-name-selected').text(frameColor);
          $('.collection-frames-swatches input[value="'+ frameColor +'"]').each(function(){
            $(this).prop('checked', true);
          });
          $('.product-card').each(function(){
            $(this).attr('data-frame-color', '');
          });
          localStorage.setItem('frameColor', JSON.stringify(frameColor));
      } else {
          $('#product-grid').removeClass($(this).value);
      }
  });

  $('.grid-item-frames .collection-frames-swatches input:radio').click(function(e){
      e.preventDefault();
      $('.grid-item-frames .collection-frames-swatches input:radio').each(function(){
        $(this).removeClass('checked');
      });
      $(this).addClass('checked');
      if($(this).is(":checked")) {
          var itemframeColor = $(this).val();
           $(this).closest('.product-card').attr('data-frame-color', itemframeColor);
      } else {
          $(this).closest('.product-card').removeClass($(this).value);
      }
  });

})(jQuery);

function refreshCollectionFrames() {

  setTimeout(function(){
    var frameColor = $('.collection-frames-swatches ul li:first-of-type input').val();
    $('.frame-name-selected').text(frameColor);
    $('.collection-frames-swatches ul li:first-of-type input').each(function(){
      $(this).prop('checked', true);
      $(this).addClass('checked');
      $(this).click();
    });
  }, 200);

  

  $('.main-frames .collection-frames-swatches input:radio').click(function(e){
    e.preventDefault();
    $('.main-frames .collection-frames-swatches input:radio').each(function(){
      $(this).removeClass('checked');
    });
    $(this).addClass('checked');
    if($(this).is(":checked")) {
      var frameColor = $(this).val();
      $('#product-grid').attr('data-frame-color', frameColor);
      $('.frame-name-selected').text(frameColor);
      $('.collection-frames-swatches input[value="'+ frameColor +'"]').each(function(){
        $(this).prop('checked', true);
      });
      $('.product-card').each(function(){
        $(this).attr('data-frame-color', '');
      });
      localStorage.setItem('frameColor', JSON.stringify(frameColor));
    } else {
      $('#product-grid').removeClass($(this).value);
    }
  });

  $('.grid-item-frames .collection-frames-swatches input:radio').click(function(e){
    e.preventDefault();
    if($(this).is(":checked")) {
      var itemframeColor = $(this).val();
      $(this).closest('.product-card').attr('data-frame-color', itemframeColor);
    } else {
      $(this).closest('.product-card').removeClass($(this).value);
    }
  });
  console.log('updated');
}

document.addEventListener("shopify:section:load", this.refreshCollectionFrames);
document.addEventListener("shopify:section:reorder", this.refreshCollectionFrames);
document.addEventListener("shopify:block:select", this.refreshCollectionFrames);
document.addEventListener("shopify:block:deselect", this.refreshCollectionFrames);
